import {Modal} from "reactstrap";
import React from 'react';
import {RegisterGuestForm} from "../Forms/RegisterGuestForm";

export const RegisterGuestModal = ({isOpen, toggle, eventId}) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} backdrop="static">
      <RegisterGuestForm
        isModalRegisterAndVoteOpen={isOpen}
        togModalRegisterAndVote={toggle}
        eventId={eventId}
      />
    </Modal>
  );
}
